import React, { useContext, useEffect } from 'react';
import { AccordionContext } from './AccordionContext';
import './HeadlessAccordion.scss';

export type Props = {
  children: React.ReactNode;
  trigerId: string;
  panelId: string;
  isOpen?: boolean;
};
const Trigger = ({
  children,
  trigerId = 'accordion1id',
  panelId = 'sect1',
  isOpen = false,
}: Props) => {
  const { expanded, setExpanded } = useContext(AccordionContext);
  useEffect(() => {
    setExpanded(isOpen);
  }, [isOpen]);
  return (
    <h3>
      <button
        type="button"
        aria-expanded={expanded}
        className={`accordion-trigger ${expanded ? 'expanded' : 'collapsed'}`}
        aria-controls={panelId}
        id={trigerId}
        onClick={() => setExpanded(!expanded)}
      >
        {children}
      </button>
    </h3>
  );
};

export default Trigger;
